<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wD2qRN/tc-custom/9781634868129.jpg?1723405969769" alt="This image is the cover for the book 12 Drummers Thumbing"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">12 Drummers Thumbing
      </h1>
      <p class="bookDescription body article font2">
        <p>Because of his severe stutter, Atticus never fulfills his childhood wish to make a joyful noise onstage at Christmastime. Now going by AC, the same problem isolates him with only his cat Spud for company as he forgoes the holiday season and personal, meaningful relationships altogether.<br/><br/>On their way to pass the yuletide in Mexico, AC and Spud encounter a stranded band who call themselves The 12 Drummers Drumming. Though AC tries to resist the urge to help, he’s somehow convinced to drive them back up north in his van to ensure they make their Christmas Eve gig.<br/><br/>AC immediately rates each guy, figuring on a one in twelve chance to at least score a holiday hookup. As he spends time with each, he sees them in less superficial terms. Sparks ignite, and by the time Christmas Eve arrives, AC has a whole new reason to believe in Christmas magic and romance.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Connor, E.F. Mulder
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?77f25250